import { Col, Row } from "@govlaunch/core";
import React from "react";
import * as palette from "@govlaunch/palette";
import MakersM from "~/components/icons/MakersM";
import WhoIsIn from "~/components/makers/WhoIsIn";
import useIsMobile from "~/lib/hooks/useIsMobile";
import { FormattedMessage } from "react-intl";

interface IMakersPageHeaderProps {
  userHasOwnerRights: boolean;
}

export default function MakersPageHeader({ userHasOwnerRights }: IMakersPageHeaderProps) {
  const isMobile = useIsMobile();

  return (
    <Row>
      <Col width={1}>
        <div
          css={{
            textAlign: "center",
            position: "relative",
          }}
        >
          {userHasOwnerRights && (
            <>
              {!isMobile && (
                <div
                  css={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                >
                  <UpgradeNowButton />
                </div>
              )}

              {isMobile && (
                <div
                  css={{
                    marginBottom: 30,
                  }}
                >
                  <UpgradeNowButton />
                </div>
              )}
            </>
          )}

          <div
            css={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MakersM />
          </div>

          <h1
            css={{
              fontSize: 44,
            }}
          >
            Makers
          </h1>

          <h3
            css={{
              fontWeight: "normal",
              fontSize: 22,
            }}
          >
            <FormattedMessage defaultMessage="A suite of tools to help you" id="2JkYoa" />{" "}
            <strong
              css={{
                fontWeight: 600,
              }}
            >
              <FormattedMessage defaultMessage="connect with local governent innovators" id="r2lHNq" />.
            </strong>
          </h3>

          <div
            css={{
              marginTop: 40,
            }}
          >
            <WhoIsIn />
          </div>
        </div>
      </Col>
    </Row>
  );
}

export const CHOOSE_YOUR_PLAN_CONTAINER_ID = "ChooseYourPlan";

function UpgradeNowButton() {
  return (
    <button
      type="button"
      onClick={() => {
        const node = document.getElementById(CHOOSE_YOUR_PLAN_CONTAINER_ID);

        if (node) {
          node.scrollIntoView({
            behavior: "smooth",
          });
        }
      }}
      css={{
        display: "inline-flex",
        margin: 0,
        border: `solid 1px ${palette.innovatorBlue}`,
        borderRadius: 20,
        padding: "4px 12px",
        color: palette.innovatorBlue,
        fontWeight: "bold",
        fontSize: 14,
        lineHeight: 1.33,
        textTransform: "uppercase",
        backgroundColor: "transparent",
        outline: "none",
        cursor: "pointer",
      }}
    >
      <FormattedMessage defaultMessage="Upgrade Now" id="2LslN1" />!
    </button>
  );
}
